module.exports = __webpack_public_path__ + "img/btn_down.8d7cb1b2.svg";